/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import type { StylesObject } from "./utils/prefixStyles";

type Props = {
  label: string,
  style?: ?StylesObject,
  colors: ColorSet,
};

class Heading extends React.Component<Props> {
  render() {
    const { label, style, colors } = this.props;
    const headingStyle = {
      // from heading.styl in nx_elements
      fontSize: "1.1em",
      textAlign: "left",
      color: colors.TITLE,
      marginBottom: ".5em",
      marginTop: "1em",
      ...style,
    };
    return <div style={headingStyle}>{label}</div>;
  }
}

export default withColorsProvider(Heading);



// WEBPACK FOOTER //
// ../nx-components/src/Heading.jsx